import { useDispatch } from "react-redux";
import { setAuth } from "components/feature/auth/actions";

const useHandleError = () => {
  const dispatch = useDispatch();

  const onHandleError = () => {
    // dispatch(
    //   setAuth({
    //     shouldShowSlideUpDialog: true,
    //   })
    // );
  };

  return [onHandleError];
};

export default useHandleError;
